{
  "title": "Rendez-vous",
  "description": "Consultez et gérez vos rendez-vous",
  "searchPlaceholder": "Rechercher des rendez-vous...",
  "emptyTitle": "Aucun rendez-vous pour le moment",
  "emptyDescription": "Vous n'avez pas encore reçu de rendez-vous. Lorsque des clients réservent vos services, ils apparaîtront ici.",
  "viewDetails": "Voir les détails",
  "columns": {
    "customer": "Client",
    "service": "Service",
    "date": "Date",
    "time": "Heure",
    "status": "Statut",
    "booking": "Réservation"
  },
  "status": {
    "all": "Tous",
    "pending": "En attente",
    "active": "Actif",
    "inProgress": "En cours",
    "completed": "Terminé",
    "cancelled": "Annulé",
    "expired": "Expiré",
    "rescheduleRequested": "Report demandé",
    "approved": "Approuvé",
    "rejected": "Refusé",
    "reported": "Signalé"
  },
  "show": {
    "title": "Détails du rendez-vous",
    "documentTitle": "Rendez-vous {{name}}",
    "documentTitleFallback": "Détails du rendez-vous",
    "description": "Consultez les informations du rendez-vous pour {{service}}",
    "thisService": "ce service",
    "actions": "Actions",
    "requestReschedule": "Demander un report",
    "sendingRequest": "Envoi de la demande...",
    "notFoundTitle": "Rendez-vous introuvable",
    "notFoundDescription": "Le rendez-vous que vous recherchez est introuvable.",
    "loadFailed": "Échec du chargement du rendez-vous",
    "backToAppointments": "Retour aux rendez-vous",
    "date": "Date",
    "time": "Heure",
    "serviceInformation": "Informations sur le service",
    "serviceName": "Nom du service",
    "unit": "Unité",
    "rating": "Note",
    "customer": "Client",
    "serviceProvider": "Prestataire",
    "noEmail": "Aucun e-mail",
    "quickActions": "Actions rapides",
    "emailCustomer": "Envoyer un e-mail au client",
    "idNotFound": "ID du rendez-vous introuvable",
    "rescheduleSuccess": "Demande de report envoyée avec succès",
    "rescheduleFailed": "Échec de la demande de report",
    "markInProgress": "Marquer en cours",
    "markingInProgress": "Marquage en cours...",
    "inProgressSuccess": "Rendez-vous marqué en cours",
    "inProgressFailed": "Échec du marquage en cours",
    "complete": "Marquer terminé",
    "completing": "Finalisation...",
    "completeSuccess": "Rendez-vous marqué terminé",
    "completeFailed": "Échec de la finalisation",
    "cancelAppointment": "Annuler le rendez-vous",
    "cancelling": "Annulation...",
    "cancelSuccess": "Rendez-vous annulé",
    "cancelFailed": "Échec de l'annulation",
    "acceptReschedule": "Accepter le report",
    "acceptingReschedule": "Acceptation...",
    "acceptRescheduleSuccess": "Report accepté",
    "acceptRescheduleFailed": "Échec de l'acceptation du report",
    "rejectReschedule": "Refuser la demande de report",
    "rejectingReschedule": "Refus...",
    "rejectRescheduleSuccess": "Demande de report refusée",
    "rejectRescheduleFailed": "Échec du refus de la demande",
    "initiateAdditionalFee": "Demander un supplément",
    "initiateAdditionalFeeDescription": "Demandez un paiement supplémentaire au client pour ce rendez-vous.",
    "feeAmount": "Montant",
    "feeAmountInvalid": "Saisissez un montant valide supérieur à zéro",
    "initiateFee": "Envoyer la demande",
    "initiatingFee": "Envoi...",
    "feeInitiatedSuccess": "Demande de supplément envoyée",
    "feeInitiatedFailed": "Échec de la demande de supplément",
    "notes": "Notes",
    "notePlaceholder": "Ajoutez une note sur ce rendez-vous...",
    "addNote": "Ajouter une note",
    "addingNote": "Ajout...",
    "noteRequired": "Saisissez une note avant d'enregistrer",
    "noteAddedSuccess": "Note ajoutée",
    "noteAddedFailed": "Échec de l'ajout de la note",
    "notesLoadFailed": "Échec du chargement des notes",
    "noNotes": "Aucune note pour le moment",
    "reschedulePendingHint": "En attente de l'acceptation du report par le client."
  },
  "bookAppointment": "Prendre rendez-vous",
  "bookForCustomer": "Prendre rendez-vous pour ce client",
  "booking": {
    "title": "Prendre rendez-vous",
    "adminTitle": "Prendre rendez-vous (admin)",
    "description": "Créer un rendez-vous pour le compte d'un client.",
    "adminDescription": "Sélectionnez une entreprise, puis réservez pour l'un de ses clients.",
    "success": "Rendez-vous réservé avec succès",
    "loadingSlots": "Chargement des créneaux disponibles...",
    "noSlots": "Aucun créneau disponible pour cette date.",
    "freeServiceHint": "Ce service est gratuit — aucun paiement requis.",
    "customer": {
      "createNew": "Nouveau client",
      "searchExisting": "Client existant"
    },
    "steps": {
      "customer": { "title": "Client", "description": "Rechercher ou créer le client." },
      "service": { "title": "Service", "description": "Choisir le service et le prestataire." },
      "schedule": { "title": "Date et heure", "description": "Choisir un créneau disponible." },
      "payment": { "title": "Paiement", "description": "Choisir le mode de paiement." },
      "confirm": { "title": "Confirmer", "description": "Vérifier et envoyer." }
    },
    "fields": {
      "business": "Entreprise",
      "customerName": "Nom du client",
      "customerEmail": "E-mail",
      "customerPhone": "Téléphone",
      "customerSearch": "Rechercher des clients",
      "customerSearchPlaceholder": "Rechercher par nom, e-mail ou téléphone",
      "customerSelectPlaceholder": "Sélectionner un client",
      "service": "Service",
      "servicePlaceholder": "Sélectionner un service",
      "provider": "Prestataire (optionnel)",
      "providerPlaceholder": "Tout prestataire disponible",
      "date": "Date",
      "timeSlot": "Créneau",
      "paymentMode": "Mode de paiement",
      "momoNumber": "Numéro mobile money",
      "momoNetwork": "Réseau (MTN, Vodafone, etc.)",
      "paymentMethodId": "ID de moyen de paiement enregistré",
      "paymentMethodIdPlaceholder": "ID carte ou MoMo enregistré du client",
      "paymentMethodIdHint": "Utilisez un ID enregistré à la place du MoMo, ou laissez vide pour débiter le numéro ci-dessus.",
      "staffNotes": "Notes du personnel",
      "staffNotesPlaceholder": "Notes d'accueil (optionnel)"
    },
    "paymentModes": {
      "offline": "Espèces / hors ligne",
      "payment_link": "Envoyer un lien de paiement",
      "staff_online": "MoMo saisi par le personnel"
    },
    "actions": {
      "back": "Retour",
      "next": "Suivant",
      "confirm": "Confirmer la réservation",
      "submitting": "Réservation..."
    },
    "errors": {
      "businessRequired": "Sélectionnez d'abord une entreprise",
      "customerRequired": "Impossible de résoudre le client",
      "slotRequired": "Sélectionnez un créneau",
      "loadSlots": "Impossible de charger les créneaux",
      "submit": "Impossible de finaliser la réservation"
    },
    "audit": {
      "bookedBy": "Réservé par {{name}}",
      "sourceConsole": "Console staff",
      "sourceProvider": "App prestataire",
      "sourceAdmin": "Admin plateforme",
      "sourceCustomer": "App client",
      "sourceUnknown": "Réservation staff",
      "paymentUnknown": "Paiement staff",
      "sourceConsoleShort": "Console",
      "sourceProviderShort": "App prestataire",
      "sourceAdminShort": "Admin",
      "staffBooked": "Réservation staff"
    },
    "intake": {
      "title": "Questions d'accueil",
      "description": "Répondez aux questions requises pour ce service.",
      "required": "Cette question est obligatoire"
    }
  }
}
